// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Shared utilities for node registries.
 */

export const DEFAULT_ORDER = 999
export const DEFAULT_CATEGORY_ORDER = 1000

/**
 * Category display presets with label and sort order.
 * Pipeline node categories only - layout categories use their own display metadata.
 */
export const CATEGORY_PRESETS: Record<string, { label: string; order: number }> = {
  datasource: { label: 'Datasource', order: 10 },
  processing: { label: 'Processing', order: 20 },
  analysis: { label: 'Analysis', order: 30 },
}

/**
 * Converts a kebab-case or snake_case string to Start Case.
 */
export function startCase(value: string): string {
  return value
    .replace(/[-_]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (match) => match.toUpperCase())
}
